<template>
  <v-form v-if="isAdmin" v-model="valid" lazy-validation>
    <v-card v-if="localCourse">
      <v-card-title>
        <span class="text-h5">
          {{ formTitle }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              label="Nom:"
              v-model="localCourse.name"
              required
              :rules="[() => !!localCourse.name || 'Champ obligatoire']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              label="Type:"
              v-model="localCourse.type"
              :items="[
                { text: 'Français', value: 'fr' },
                { text: 'Français à distance', value: 'frdistance' },
                { text: 'Approche du monde professionnel et techniques de recherche d\'emploi', value: 're' },
                { text: 'Informatique', value: 'it' },
                { text: 'Cours privé', value: 'cp' },
              ]"
              required
              :rules="[() => !!localCourse.type || 'Champ obligatoire']"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-combobox
              clearable
              multiple
              small-chips
              label="Niveaux des élèves:"
              v-model="localCourse.levels"
              :items="localCourse.levelVariants"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field label="Salle:" v-model="localCourse.room"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-menu
              required
              ref="menu1"
              :close-on-content-click="true"
              v-model="menu1"
              :nudge-right="40"
              :return-value.sync="localCourse.start"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="localCourse.start"
                  label="Date de début:"
                  prepend-icon="mdi-calendar"
                  required
                  readonly
                  :rules="[() => !!localCourse.start || 'Champ obligatoire']"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="fr-CH"
                first-day-of-week="1"
                :max="localCourse.end"
                v-model="localCourse.start"
                @input="$refs.menu1.save(localCourse.start)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              required
              ref="menu2"
              :close-on-content-click="true"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="localCourse.end"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="localCourse.end"
                  label="Date de Fin:"
                  prepend-icon="mdi-calendar"
                  required
                  :rules="[() => !!localCourse.end || 'Champ obligatoire']"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="fr-CH"
                first-day-of-week="1"
                :min="localCourse.start"
                v-model="localCourse.end"
                @input="$refs.menu2.save(localCourse.end)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11" sm="5">
            <v-menu
              ref="menu"
              v-model="menu_start_hours"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="localCourse.start_hours"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localCourse.start_hours"
                  label="De"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu_start_hours"
                color="green lighten-1"
                v-model="localCourse.start_hours"
                format="24hr"
                @click:minute="$refs.menu.save(localCourse.start_hours)"
              ></v-time-picker>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="11" sm="5">
            <v-dialog
              ref="dialog"
              v-model="modal_end_hours"
              :return-value.sync="localCourse.end_hours"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localCourse.end_hours"
                  label="A"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="modal_end_hours"
                v-model="localCourse.end_hours"
                color="green lighten-1"
                format="24hr"
              ></v-time-picker>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="modal_end_hours = false">Annuler</v-btn>
              <v-btn color="primary" @click="$refs.dialog.save(localCourse.end_hours)">OK</v-btn>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h3>Jours de cours:</h3>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.monday" label="Lundi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.tuesday" label="Mardi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.wednesday" label="Mercredi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.thursday" label="Jeudi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.friday" label="Vendredi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.saturday" label="Samedi" hide-details></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox v-model="localCourse.sunday" label="Dimanche" hide-details></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            Durée: {{ localCourse.working_days.length }}
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="autocalculate()">Autocalculer</v-btn>
          </v-col>
          <v-col cols="12">
            <v-date-picker
              locale="fr-CH"
              first-day-of-week="1"
              v-model="localCourse.working_days"
              multiple
              no-title
              v-if="canCalculateCourseDays"
            ></v-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h3>Formateurs</h3>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="localCourse.prof1"
              label="Formateur/trice 1"
              required
              :rules="[() => !!localCourse.prof1 || 'Champ obligatoire']"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="localCourse.prof2" label="Formateur/trice 2"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="localCourse.drive_link" label="Google Drive lien:"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea outlined name="input-7-1" label="Commentaire" v-model="localCourse.comment"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.native="close">Annuler</v-btn>
        <v-btn :disabled="isDisabled" color="blue darken-1" text @click.native="save">Sauvegarder</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex"
import { cloneDeep } from "lodash"
import Course from "@/models/Course"

export default {
  props: {
    formTitle: {
      default: "Modifier Course",
      type: String,
    },
    course: {
      required: true,
    },
  },
  mounted() {
    this.localCourse = cloneDeep(this.course)
  },
  watch: {
    course: function () {
      this.localCourse = cloneDeep(this.course)
    },
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu_start_hours: false,
      modal_end_hours: false,
      edit: false,
      valid: false,
      localCourse: new Course(),
      isDateManualEdit: false,
    }
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    isDisabled() {
      return (
        !this.localCourse.start ||
        !this.localCourse.end ||
        !this.localCourse.prof1 ||
        !this.localCourse.start_hours ||
        !this.localCourse.end_hours ||
        !(
          this.localCourse.sunday ||
          this.localCourse.saturday ||
          this.localCourse.monday ||
          this.localCourse.tuesday ||
          this.localCourse.wednesday ||
          this.localCourse.thursday ||
          this.localCourse.friday
        )
      )
    },
    canCalculateCourseDays() {
      let start = this.localCourse?.start
      let end = this.localCourse?.end

      if (!start || !end || !this.weekDaysArray.length) {
        return false
      }
      return true
    },
    weekDaysArray() {
      let resultArray = []
      if (this.localCourse.monday) {
        resultArray.push(1)
      }
      if (this.localCourse.tuesday) {
        resultArray.push(2)
      }
      if (this.localCourse.wednesday) {
        resultArray.push(3)
      }
      if (this.localCourse.thursday) {
        resultArray.push(4)
      }
      if (this.localCourse.friday) {
        resultArray.push(5)
      }
      if (this.localCourse.saturday) {
        resultArray.push(6)
      }
      if (this.localCourse.sunday) {
        resultArray.push(0)
      }
      return resultArray
    },
  },
  methods: {
    save() {
      this.$emit("save", this.localCourse)
    },
    close() {
      {
        this.$emit("cancel")
      }
    },
    //calculate days depending on start and end dates and working weekdays
    autocalculate() {
      let start = this.localCourse?.start
      let end = this.localCourse?.end
      let weekdays = this.weekDaysArray

      var dateArray = []
      var currentDate = new Date(start)
      var endDate = new Date(end)

      while (currentDate <= endDate) {
        let dateToAdd = new Date(currentDate)
        let dateToAddWeekDay = dateToAdd.getDay()

        if (weekdays.includes(dateToAddWeekDay)) {
          const formattedDate = dateToAdd.toLocaleDateString("en-CA") // returns local date with YYYY-MM-DD format
          dateArray.push(formattedDate)
        }
        currentDate.setDate(currentDate.getDate() + 1)
      }
      this.localCourse.working_days = dateArray

      if (this.localCourse?.working_days) return this.localCourse.working_days
    },
  },
}
</script>
<style>
.v-date-picker-table {
  height: 100%;
}
</style>
